import { BookingClassesWrapper } from "./booking.type";
import { ClassInstance } from "./class.type";
import { WorkoutScreenData } from "./screen.type";

export interface Events {
    classWorkoutAboutToStart: ClassInstance;
    classDataUpdated: ClassInstance;
    classWorkoutStart: ClassInstance;
    classNextWorkout: ClassInstance;
    newScreenData: WorkoutScreenData;
    bookingClassesWrapper: BookingClassesWrapper;
    movementDataUpdated: ClassInstance;
    timerPreWorkout: ClassInstance;
    timerStartWorkout: ClassInstance;
}

export enum RenderEvents {
    classWorkoutAboutToStart = 'classWorkoutAboutToStart',
    classDataUpdated = 'classDataUpdated',
    classWorkoutStart = 'classWorkoutStart',
    classNextWorkout = 'classNextWorkout',
    bookingClassesWrapper = 'bookingClassesWrapper',
    movementDataUpdated = 'movementDataUpdated',
    timerPreWorkout = 'timerPreWorkout',
    timerStartWorkout = 'timerStartWorkout',
}

export enum CoreEvents {
    classWorkoutAboutToStart = 'classWorkoutAboutToStart',
    classDataUpdated = 'classDataUpdated',
    classWorkoutStart = 'classWorkoutStart',
    classNextWorkout = 'classNextWorkout',
    bookingClassesWrapper = 'bookingClassesWrapper',
    bookingDataUpdated = 'bookingDataUpdated',
    movementDataUpdated = 'movementDataUpdated',
}


export enum MqttEvents {
    onMessage = 'mqttOnMessage',
    sendMessage = 'mqttSendMessage',
    connect = 'mqttConnect',
    disconnect = 'mqttDisconnect',
}